import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    dialogContentRoot: {
      paddingTop: 0,
      '&:first-of-type': {
        paddingTop: 0,
      },
    },
    dialogBottomInfo: {
      display: 'flex',
    },
    employeeInfoContainer: {
      marginRight: theme.spacing(4),
    },
  };
};
